import { Component, OnInit, OnDestroy, Optional, Injectable, ChangeDetectorRef } from '@angular/core';
import { GSBaseControl } from './gs.base.control';
import { FormSelectButtonProperty } from '../entity/form/formSelectButton.property';
import { Item } from '../entity/entities';

@Component({
  selector: 'gs-select-button',
  templateUrl: './gs.selectButton.control.html'
})
@Injectable()
export class GSSelectButtonControl extends GSBaseControl implements OnInit, OnDestroy {
  private lastValue: any;

  constructor(@Optional() prop: FormSelectButtonProperty, @Optional() item: Item, private changeDr: ChangeDetectorRef) {
    super(changeDr);
    this.property = prop;
    this.item = item;
  }

  ngOnInit() {
    this.lastValue = this.value;
  }

  ngOnDestroy() {
  }

  changeV(e) {
    if (e === null || e === undefined) {
      this.value = this.lastValue;
      this.changeDr.detectChanges();
      return;
    }
    let previousValue = this.data[this.name];
    this.lastValue = e;
    this.data[this.name] = e;
    this.value = e;
    this.item.reCheckDirty();
    this.onChange.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
    this.property.changed.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
  }
}
